// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng builprod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
import * as CryptoJS from 'crypto-js';
let cv = '';
function generateRandomString(_length) {
  let text = '';
  const codeVerifier = sessionStorage.getItem('code_verifier');
  if (codeVerifier !== null && codeVerifier !== undefined && codeVerifier !== '') {
    cv = codeVerifier;
    return codeVerifier;
  } else {
    text +=  window.crypto.getRandomValues(new Uint8Array(256));
    cv = text;
    sessionStorage.setItem('code_verifier', cv);
    return text;
  }
}
function generateCodeChallenge(codeVerifier) {
  const codeChallange = base64URL(CryptoJS.SHA256(codeVerifier));
  return codeChallange + '&code_challenge_method=S256';
}
function base64URL(string: any) {
  return string.toString(CryptoJS.enc.Base64).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_')
}
export const environment = {
  production: false,
  envName: 'local',
  apiBaseUrl:'http://localhost:',
  getXApiKeyUrl: 'https://api.qa.bpg.toyota.com/v7/qa/get-bpg-keys',
  codeVerifier: generateRandomString(128),
  codeChallenge: generateCodeChallenge(cv),
  logoutUrl : 'https://login.microsoftonline.com/common/oauth2/logout',
  tokenUrl : 'https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef/oauth2/v2.0/token',
  reportUrl1:'https://app.powerbi.com/groups/me/apps/0d0ac254-5b0f-4b27-a747-18a5f4e48961/reports/df79dca5-6ec5-4189-a7e2-7f76f2ea94b3/ReportSection',
  reportUrl2:'https://app.powerbi.com/groups/me/apps/0d0ac254-5b0f-4b27-a747-18a5f4e48961/reports/f0cffd0e-5a73-4417-973f-463610af4ce2/ReportSectioncfc0ba450303c05c9757',
  reportUrl3:'https://app.powerbi.com/groups/me/apps/0d0ac254-5b0f-4b27-a747-18a5f4e48961/reports/234330df-68c5-4c20-aa56-d7afb0ee0c47/ReportSection',
  reportUrl4:'https://app.powerbi.com/groups/me/apps/0d0ac254-5b0f-4b27-a747-18a5f4e48961/reports/93eb357f-4ef0-4177-9cd5-9afc4d2e90c1/ReportSection',
  reportUrl5:'https://app.powerbi.com/groups/me/apps/0d0ac254-5b0f-4b27-a747-18a5f4e48961/reports/b1059bdc-fe35-48b1-bb44-38d518c7d0b5/ReportSection',
  reportUrl6:'https://app.powerbi.com/groups/me/apps/0d0ac254-5b0f-4b27-a747-18a5f4e48961/reports/b3182ad3-e981-41f1-b616-3f607805b408/ReportSection',
  reportUrl7:'https://app.powerbi.com/groups/me/apps/0d0ac254-5b0f-4b27-a747-18a5f4e48961/reports/e052b1ee-2f69-4e2e-96ce-3710fab6ec30/ReportSection',
  reportUrl8:'https://app.powerbi.com/groups/me/apps/0d0ac254-5b0f-4b27-a747-18a5f4e48961/reports/ab2d6f8d-1289-4a56-b325-77b5d7596ecd/ReportSection',
  reportUrl9:'https://app.powerbi.com/groups/me/apps/0d0ac254-5b0f-4b27-a747-18a5f4e48961/reports/8e4c65d2-680a-4625-9fda-704fe1be016d/ReportSectiondeb2fc35cb660b3d22d7',
  reportUrl10:'https://app.powerbi.com/groups/me/apps/0d0ac254-5b0f-4b27-a747-18a5f4e48961/reports/fc4d87c2-734b-4802-ade1-076814b65dc0/ReportSection',

  logger: {
    level: 'DEBUG'
  },
  xApiKey:'',
  adalConfig: {
    tenant: '9107b728-2166-4e5d-8d13-d1ffdf0351ef',
    clientId: '75d45676-41d5-4794-9b62-0c93330906e7',
 redirectUri: 'https://dev.bpg.toyota.com.s3-website-us-west-2.amazonaws.com/site-home'
  },
  loginADAL:false
};
